interface IResponse {
  code: number;
  message: string;
  ttl: number;
  // data: any;
}

// 业务场景，不同场景可能有定制的价格面板数据：钱包处面板为1，直播送礼处面板为2，活动面板为3
export enum BizID {
  CASHIER = 1,
  LIVE_GIFT = 2,
  ACITVITY = 3,
}

// 获取商品列表
export interface IRechargePanelRequest {
  biz_id: BizID;
  platform: string; // 平台, web直播间默认web
}

export interface IRechargePanelResponse extends IResponse {
  data: IRechargePanelData
}

export interface IRechargePanelData {
  balance: number; // Stars余额
  products: IProduct[]; // 面板中商品列表
  protocol_url: string; // 协议链接
  notice_url: string; // 规则链接，若提供则展现
}

// 商品信息
export interface IProduct {
  product_id: string; // 商品id，e.g. bstar.star.70.ios
  product_code: string;
  stars: number; // 星星数量
  product_name: string; // 商品名，用于web端cashier页展示，e.g. BiliBili Stars
  discount_price: string; // 折后价，用于web端cashier页展示，e.g. 1.33
  currency: string; // 币种，用于web端cashier页展示，e.g. $
  fee_type: string; // 支付类型
}

export interface IChannelData {
  channels: IChannel[];
  product_code: string // 商品代码
}

export interface IChannel {
  pay_channel:  string; //"payerMaxPay",
  real_channel: string;
  pay_channel_id: string;
  sub_pay_channel_id: number;
  channel_product_id: string;
  pay_channel_name: string;
  pay_channel_logo: string;
  currency_symbol: string;
  price: string;
  original_price: string;
}

// 发起Stars充值
export interface ICreateOrderRequest {
  biz_id: BizID;
  product_code: string; // 商品code
  pay_channel: string; // 下单渠道
  pay_channel_id: string; // 下单渠道id
  sub_pay_channel_id: number; // 下单的子渠道id
  product_id: string; // 商品id，channel_product_id
  return_url?: string; // 充值成功后的跳转链接，若未提供，则默认跳转到web首页，待web有钱包页后改成跳转到钱包页
}

export interface ICreateOrderResponse extends IResponse {
  data: ICreateOrderData;
}

export interface ICreateOrderData {
  order_id: string; // 订单id
  pay_data: string; // 支付平台请求的结构体，详见https://info.bilibili.co/pages/viewpage.action?pageId=441581358
}

// 商品信息
export interface IPayData {
  coinFeeType: string; //  虚拟币类型，STAR
  coinQuantity: string; // 虚拟货币数量
  countryCode: string; //国家码
  customerId: number;
  customerProductCode: string;
  deviceType: number;
  failUrl: string;
  feeType: string;
  notifyUrl: string;
  orderCreateTime: string;
  orderExpire: number;
  orderId: string;
  originalAmount: number;
  payAmount: number;
  priceCriterion: string;
  productId: string;
  returnUrl: string;
  serviceType: number;
  showTitle: string;
  sign: string;
  signType: string;
  timestamp: number;
  traceId: string;
  transType: string; //  1-虚拟币充值交易
  uid: number;
  version: string;
}

// 查询Stars充值订单
export interface IQueryOrderRequest {
  order_id: string; // 订单id
  platform: string; // 平台, web直播间默认web
}

export interface IQueryOrderResonse extends IResponse {
  data: IQueryOrderData;
}

export enum IOrderStatus {
  PROCESSING = 1,
  TIMEOUT_CLOSE = 2,
  FAIL = 3,
  SUCCESS = 4,
  CANCEL = 5,
}

export interface IQueryOrderData {
  order_id: string; // 订单id
  balance: number; // 星星余额
  status: IOrderStatus; // 订单状态, WEB端可根据是否为 4-成功 进行轮询
}
